import React, { FC, useEffect, useState } from 'react';
import Modal from 'react-modal';
import { modalOverlayBackgroundColor } from 'util/constants';
import Notes from './Notes';
import CloseIcon from '../../Icons/Close';

const MODAL_STYLE = {
  content: {
    maxWidth: '1200px',
    maxHeight: '700px',
    width: '100%',
    left: 0,
    top: 80,
    margin: '0 auto',
    position: 'relative' as 'relative',
    background: 'white',
    border: '1px solid lightgrey',
    boxShadow: '0 1px 1px 0 lightgrey',
    outline: 'none',
    padding: '20px',
  },
  overlay: {
    background: modalOverlayBackgroundColor,
  },
};

const NotesModal: FC<{
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onChange: (note: string, callback: () => void) => void;
  onShowRicTab: (e: Event) => void;
}> = props => {
  const [note, setNote] = useState('');

  useEffect(() => {
    // Reset note when modal is open
    setNote('');
  }, [props.isOpen]);

  const submitNote = () => {
    // Set note value, submit after the state is updated
    props.onChange(note, () => {
      props.onSubmit();
      setNote('');
    });
  };

  return (
    <Modal
      isOpen={props.isOpen}
      style={MODAL_STYLE}
      className="notes-modal-container"
    >
      <CloseIcon onClick={props.onClose} />
      <Notes
        {...props}
        note={note}
        onChange={setNote}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            submitNote();
          }
        }}
        showOfferAndRicTab={e => {
          props.onClose();
          props.onShowRicTab(e);
        }}
      />
      <div className="notes-modal-footer">
        <button className="notes-modal-button-cancel" onClick={props.onClose}>
          Cancel
        </button>
        <button
          key="save"
          className="notes-modal-button-save"
          onClick={submitNote}
        >
          Send to Salesperson
        </button>
      </div>
    </Modal>
  );
};

export default NotesModal;
